import React from 'react';
import { CompanyLogoInfo } from '../DataStructures/CompanyLogos';
import { useApiGet } from '../../api/api.hooks';
import { APP_CONFIG } from '../../config';
import { CompanyLogo } from '../../lib/CompanyLogo';

interface Props {
  companyId: number | string;
}

export function ApiCompanyLogo({ companyId }: Props) {
  const logosUrl = (window as any).REACT_APP_VARIABLES.LogosUrl;

  const logo: CompanyLogoInfo = {
    desktop: { src: `${logosUrl}/desktop/${companyId}.png`, alt: '' },
    mobile: { src: `${logosUrl}/mobile/${companyId}.png`, alt: '' },
  };
  return <CompanyLogo logo={logo} />;
}
